import { render, staticRenderFns } from "./chemruleDetail.vue?vue&type=template&id=e7c51526"
import script from "./chemruleDetail.vue?vue&type=script&lang=js"
export * from "./chemruleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c51526')) {
      api.createRecord('e7c51526', component.options)
    } else {
      api.reload('e7c51526', component.options)
    }
    module.hot.accept("./chemruleDetail.vue?vue&type=template&id=e7c51526", function () {
      api.rerender('e7c51526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemruleDetail.vue"
export default component.exports